export const style = {
  avilabilityTopContainer: {
    padding: "2rem 2.4rem",
    background: "var(--blue-gray-100)",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    top: "0rem",
    zIndex: 100,
  },
  availabilityLeftArrowIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "3.6rem",
    height: "3.6rem",
    borderRadius: "1.8rem",
    background: "var(--neutral-100)",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
    marginRight: "1.2rem",
    cursor: "pointer",
  },
  avilabilityTopContainerText: {
    display: "flex",
    alignItems: "center",
    "& > h4": {
      color: "var(--black-900)",
      fontSize: "2.4rem",
      fontWeight: 500,
    },
  },
  addNewAvailability: {
    display: "flex",
    "& > button:first-of-type": {
      padding: "0rem 1.5rem",
    },
  },
  deleteButtonText: {
    color: "var(--red-600)",
    fontSize: "1.4rem",
    fontWeight: 500,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1.6rem",
    backgroundColor: "var(--neutral-100)",
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  headerInnerContainer: {
    display: "flex",
    alignItems: "center",
  },
  headerText: {
    color: "var(--black-900)",
    fontSize: "1.6rem",
    fontWeight: "500",
  },
  createOrEditAvailabilityContainer: {
    padding: "1.6rem",
    display: "flex",
    flexDirection: "column",
    gap: "1.6rem",
    height: "100%",
  },
  selectText: {
    color: "var(--orange-500)",
    fontSize: "1.4rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  notAllowed: {
    color: "var(--gray-400)",
    fontSize: "1.4rem",
    fontWeight: 500,
    backgroundColor: "transparent",
    cursor: "not-allowed",
  },
  heading: {
    margin: "0rem 0rem 1.6rem 0rem",
    color: "var(--black-900)",
    fontSize: "1.6rem",
    fontWeight: 400,
  },
  selectedDate: {
    color: "var(--gray-400)",
    fontSize: "1.4rem",
    fontWeight: 400,
  },
  saveCancelBtnContainer: {
    display: { xs: "flex", lg: "none" },
    gap: 1.6,
    mx: 1.6,
    position: "sticky",
    bottom: 30,
    zIndex: 100,
  },
  saveCancelBtnContainerDesktop: {
    display: { xs: "none", lg: "block" },
    position: "sticky",
    bottom: "0rem",
    zIndex: 100,
  },
  closeIcon: {
    height: 24,
    weight: 24,
  },
  disabledChip: {
    "&.Mui-disabled": {
      border: "0.1rem solid var(--gray-200)",
      background: "var(--gray-200)",
      opacity: 1,
    },
  },
  disabledTextField: {
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: "var(--blue-gray-100)",
    },
  },
};
